/* eslint-disable no-else-return */
/* eslint-disable max-len */
import React, {
    useEffect, useCallback, useContext, useState
} from 'react';
import PropTypes from 'prop-types';
import _, { escapeRegExp } from 'lodash';
import { WizardPage, WizardPageTemplate, wizardProps } from 'gw-portals-wizard-react';
import { useDataRefresh, ViewModelForm, ViewModelServiceContext } from 'gw-portals-viewmodel-react';
import { withAuthenticationContext } from 'gw-digital-auth-react';
import { useValidation } from 'gw-portals-validation-react';
import { useDependencies } from 'gw-portals-dependency-react';
import { withRouter, useHistory } from 'react-router-dom';
import { readViewModelValue } from 'gw-jutro-adapters-react';
import { messages as commonMessages } from 'gw-platform-translations';
import { ModalNextProvider } from '@jutro/components';
import SasriaVehicleIncident_EXT from 'gw-capability-fnol-common-react/models/SasriaVehicleIncident_EXT';
import { validateRegNoCheckSum, validateIdNo } from 'sasria-capability-fnol-common-react/Validations/CheckSumValidation';
import Claim from '../../../gw-capability-fnol-common-react/models/Claim';
import styles from './SasriaVehicleIncident.module.scss';
import metadata from './SasriaVehicleIncident.metadata.json5';
import messages from './SasriaVehicleIncident.messages';
import {
    lossEstimateAmountValidation, vehicleRegistrationNoMandatory, vinnoAndEngNoMandatoryValidation, mandatoryFieldForTotalLoss, checkIfSAIdValid,
    validateLossEstimateInclAndExclValues, companyRegValidationCheck, lossEstimateAmountIncludingVATValidation
} from '../../../sasria-capability-fnol-common-react/Validations/ValidationUtil';
import {
    documentsStep,
    bankDetailsStep,
    summaryStep
} from '../../../sasria-capability-fnol-common-react/ExpressClaim/ExpressClaimSteps';

function SasriaVehicleIncident(props) {
    const {
        wizardData: claimVM,
        updateWizardData,
        history: {
            location: { state = {} }
        },
        changeNextSteps,
        authHeader
    } = props;

    const history = useHistory();
    const viewModelService = useContext(ViewModelServiceContext);
    const { FNOLService } = useDependencies('FNOLService');
    const [isLoading, setIsLoading] = useState(false);
    const [lossType, setLossType] = useState('insured');
    const [isMMCode, setIsMMCode] = useState('');
    const [accessorsCode, setAccessorsCode] = useState('');
    const [haveLossEstimateValue, setHaveLossEstimateValue] = useState('');
    const [haveTotalLossValue, setHaveTotalLossValue] = useState('');
    const [haveFinOut, setHaveFinOut] = useState('');
    const [enatisCodeValue, setEnatisCodeValue] = useState('');
    const [vehicleDataFromPolicy, setVehicleDataFromPolicy] = useState([]);
    const [policyVehicleDataList, setPolicyVehicleDataList] = useState([]);
    const [selectedVehRegNo, setSelectedVehRegNo] = useState('');
    const [addNew, setAddNew] = useState(false);
    const [yearData, setYearData] = useState([]);
    const [selectedYearValue, setSelectedYearValue] = useState(null);
    const [makeData, setMakeData] = useState([]);
    const [selectedMake, setSelectedMake] = useState('');
    const [modelData, setModelData] = useState([]);
    const [selectedModel, setSelectedModel] = useState('');
    const [variantData, setVariantData] = useState([]);
    const [selectedVariant, setSelectedVariant] = useState('');
    const [mmCodeValue, setMMCodeValue] = useState(null);
    const [addIncidentCard, setAddIncidentCard] = useState(false);
    const [vehicleIncidentArray, setVehicleIncidentArray] = useState([]);
    const [vehicleAddedFromDropDown, setVehicleAddedFromDropDown] = useState([]);
    const [regNoList, setRegNoList] = useState([]);
    const [loadingSpinner, setLoadingSpinner] = useState(false);
    const [hideNextButton, setHideNextButton] = useState(true);
    const [totalLossEstimate, setTotalLossEstimate] = useState(Number(0));
    const [isIDValid, setIDValid] = useState(true);
    const [isPassportValid, setPassportValid] = useState(true);
    const [isRegNoValid, setRegNoValid] = useState(true);
    const [isInsuredTypeCompany, setInsuredTypeCompany] = useState(true);
    const [expressClaimSelected, setExpressClaimSelected] = useState(false);
    const [isFinalLossEstimate, setFinalLossEstimate] = useState('');
    const [insuredIDVisible, setInsuredIDVisible] = useState(true);
    const [checkFinalLossVal, setCheckFinalLossVal] = useState(false);
    const [indArray, setArray] = useState([]);
    const [showLossEstimatesGlobal, setShowLossEstimatesglobal] = useState('');
    const [isEditButtonClicked, setIsEditButtonClicked] = useState(false);
    const { isComponentValid, registerComponentValidation } = useValidation('SasriaVehicleIncident');
    const [regNumber, setRegNumber] = useState('');
    const [idNumber, setIdNumber] = useState('');
    const [passportNumber, setPassportNumber] = useState('');
    const [idType, setIdType] = useState('');
    const [claimExtension, setClaimExtension] = useState('');
    const [totalLoss, setTotalLoss] = useState('');
    const [premiumCollection, setPremiumCollection] = useState('');

    const vehicleIncidentViewModel = viewModelService.create(
        _.get(claimVM.value, 'vehicleIncident_EXT') || new SasriaVehicleIncident_EXT(),
        'cc',
        'edge.capabilities.claim.fnol.dto.VehicleIncidentDTO_EXT',
    );
    const [vehicleIncidentVM] = useState(vehicleIncidentViewModel);

    const getVehicleCodefilter = useCallback((vehiclesData) => {
        return vehiclesData.map((key) => {
            return {
                code: key.vehicleRegNo,
                name: key.vehicleRegNo
            };
        });
    }, []);


    const expressClaimsStepsHandling = useCallback(() => {
        const nextSteps = [
            bankDetailsStep, documentsStep, summaryStep
        ];
        changeNextSteps(nextSteps);
        return claimVM;
    }, [changeNextSteps, claimVM]);

    const normalClaimsStepsHandling = useCallback(() => {
        const nextSteps = [
            documentsStep, summaryStep
        ];
        changeNextSteps(nextSteps);
        return claimVM;
    }, [changeNextSteps, claimVM]);

    const retrieveVehicleFromPolicy = useCallback(() => {
        return FNOLService.getVehicleDetailsFromPolicy_EXT(claimVM.value, authHeader)
            .then((vehiclesData) => {
                setPolicyVehicleDataList(vehiclesData);
                const vehiclesDataArray = getVehicleCodefilter(vehiclesData);
                setVehicleDataFromPolicy(vehiclesDataArray);
            });
    }, [FNOLService, claimVM.value, authHeader, getVehicleCodefilter]);

    const getCodefilter = useCallback((retrievedList) => {
        return retrievedList.map((key) => {
            return {
                code: key,
                name: key
            };
        });
    }, []);

    const retrieveRegYearFromTransunion = useCallback(
        () => {
            // if (yearData && yearData.length >= 1) {
            //     return yearData;
            // }
            return FNOLService.populateRegistrationYearFromTU_EXT(authHeader)
                .then((regYears) => {
                    const regYearDataArray = getCodefilter(regYears);
                    setYearData(regYearDataArray);
                });
        },
        [FNOLService, authHeader, getCodefilter],
    );

    const isNextButtonAvailableOnPrevious = useCallback(
        () => {
            const vehicleList = _.get(claimVM, 'vehicleIncidentArray_EXT.value');
            if (!_.isUndefined(vehicleList) && !_.isEmpty(vehicleList)) {
                if (vehicleList.length > 0) {
                    setHideNextButton(false);
                }
            }
        },
        [claimVM],
    );

    const handleError = (title, message) => {
        return ModalNextProvider.showAlert({
            title: title,
            message: message,
            status: 'error',
            icon: 'mi-error-outline',
            confirmButtonText: commonMessages.ok
        }).catch(_.noop);
    };

    const populateRegListonPageLoad = useCallback(
        () => {
            const vehicleList = _.get(claimVM, 'vehicleIncidentArray_EXT.value');
            if (!_.isUndefined(vehicleList) && !_.isEmpty(vehicleList)) {
                vehicleList.forEach((incident) => {
                    regNoList.push(incident.vehicleRegNo);
                });
                setRegNoList(regNoList);
            }
        },
        [claimVM, regNoList],
    );

    const checkFinalLossEstimateValidation = useCallback(() => {
        const vehicleList = claimVM.vehicleIncidentArray_EXT.value;
        let totalIncidentAmt = null;
        let lossEstimateProvided = true;
        if (!_.isUndefined(vehicleList) && !_.isEmpty(vehicleList)) {
            vehicleList.forEach((incident) => {
                const { lossEstimateInclVATValue: lossEstimate, haveLossEstimate } = incident;
                if (haveLossEstimate) {
                    if (_.isNil(totalIncidentAmt) || _.isNaN(totalIncidentAmt)) {
                        totalIncidentAmt = Number(0);
                    }
                    totalIncidentAmt += Number(lossEstimate);
                    setTotalLossEstimate(totalIncidentAmt);
                } else { lossEstimateProvided = false; }
            });
        }
        setShowLossEstimatesglobal(lossEstimateProvided);
        _.set(claimVM.value, 'totalLossEstimate_Ext', totalIncidentAmt);
        const policy = _.get(claimVM.value, 'policyData_EXT');
        const lossEstimateLimit = _.get(policy, 'agentLossEstimateLimit_Ext');
        const val = (lossEstimateProvided && (!_.isNil(totalIncidentAmt) && !_.isNaN(totalIncidentAmt)) && (!_.isNaN(lossEstimateLimit)) && (Number(totalIncidentAmt) <= Number(lossEstimateLimit)));
        setCheckFinalLossVal(val);
        if (!val) {
            setExpressClaimSelected(val);
        }
        return val;
    }, [claimVM]);


    const handleFinalLossEstimate = useCallback((value) => {
        setFinalLossEstimate(value);
        _.set(claimVM, 'isFinalLossEstimate_EXT.value', (value === 'Yes'));
        checkFinalLossEstimateValidation();
    }, [checkFinalLossEstimateValidation, claimVM]);

    const getIdentityRegNumber = useCallback((insuredType) => {
        const policy = _.get(claimVM.value, 'policyData_EXT');
        const insured = _.get(policy, 'insuredData_EXT');
        if (insured) {
            if (insuredType === 'Person') {
                if (idType === 'saId') {
                    return insured.id;
                } else {
                    return insured.passportNumber;
                }
            } else if (insuredType === 'Company') {
                return insured.regNo;
            }
        }
        return undefined;
    }, [claimVM.value, idType]);


    const getIdType = useCallback((value) => {
        setIdType(value);
        const policy = _.get(claimVM.value, 'policyData_EXT');
        const insured = _.get(policy, 'insuredData_EXT');
        if (value === 'saId') {
            setIdNumber(insured.id);
            _.set(claimVM, 'insuredIdentityNumber', insured.id);
        }
        if (value === 'passport') {
            setInsuredIDVisible(false);
            setPassportNumber(insured.passportNumber);
            _.set(claimVM, 'insuredPassportNumber', insured.passportNumber);
        }
    }, [claimVM, setIdType]);

    const getDefaultIdType = useCallback(() => {
        const policy = _.get(claimVM.value, 'policyData_EXT');
        const insured = _.get(policy, 'insuredData_EXT');
        if (insured.id && insured.passportNumber) {
            setIdType('saId');
            setIdNumber(insured.id);
        } else if (insured.id) {
            setIdType('saId');
            setIdNumber(insured.id);
        } else if (insured.passportNumber) {
            setIdType('passport');
            setPassportNumber(insured.passportNumber);
        } else { setIdType('saId'); setIdNumber(insured.id); }
    }, [claimVM, setIdType]);

    const handleCompanyRegNumber = useCallback(() => {
        if (regNumber === '') {
            const regNo = getIdentityRegNumber('Company');
            if (!_.isNil(regNo) && !_.isUndefined(regNo)) {
                setRegNumber(regNo);
                _.set(claimVM, 'companyRegistrationNumber', regNo);
                _.set(claimVM.value, 'companyRegistrationNumber', regNo);
            } else {
                _.set(claimVM, 'companyRegistrationNumber', regNumber);
                _.set(claimVM.value, 'companyRegistrationNumber', regNumber);
            }
        }
    }, [claimVM, getIdentityRegNumber, regNumber]);

    const handleIdNumber = useCallback(() => {
        if (idType === 'saId') {
            if (idNumber === '') {
                const idNo = getIdentityRegNumber('Person');
                if (!_.isNil(idNo) && !_.isUndefined(idNo)) {
                    setIdNumber(idNo);
                    _.set(claimVM, 'insuredIdentityNumber', idNo);
                    _.set(claimVM.value, 'insuredIdentityNumber', idNo);
                }
            } else {
                _.set(claimVM, 'insuredIdentityNumber', idNumber);
                _.set(claimVM.value, 'insuredIdentityNumber', idNumber);
            }
        } else {
            if (passportNumber === '') {
                const passport = getIdentityRegNumber('Person');
                if (!_.isNil(passport) && !_.isUndefined(passport)){
                    setPassportNumber(passport);
                    _.set(claimVM, 'insuredPassportNumber', passport);
                    _.set(claimVM.value, 'insuredPassportNumber', passport);
                }
            } else {
                _.set(claimVM, 'insuredPassportNumber', passportNumber);
                _.set(claimVM.value, 'insuredPassportNumber', passportNumber);
            }
        }
    }, [claimVM, getIdentityRegNumber, idNumber, idType, passportNumber]);

    const handleCompanyOrInsured = useCallback(() => {
        const policy = _.get(claimVM.value, 'policyData_EXT');
        const insured = _.get(policy, 'insuredData_EXT');
        if (insured) {
            const { insuredType } = insured;
            if (insuredType === 'InsuredCompany_EXT') {
                setInsuredTypeCompany(true);
                handleCompanyRegNumber();
            } else {
                setInsuredTypeCompany(false);
                handleIdNumber();
            }
        }
    }, [claimVM.value, handleCompanyRegNumber, handleIdNumber]);

    const onExpressClaimSwitch = useCallback((value, path) => {
        handleCompanyOrInsured();
        setExpressClaimSelected(value);
    }, [handleCompanyOrInsured]);

    const validateInsuredIdentity = useCallback(() => {
        if (!expressClaimSelected) {
            return true;
        }
        let insuredIdNumber = _.get(claimVM.value, 'insuredIdentityNumber');
        let insuredPassportNumber = _.get(claimVM.value, 'insuredPassportNumber');
        const companyRegNumber = _.get(claimVM.value, 'companyRegistrationNumber');
        const policy = _.get(claimVM.value, 'policyData_EXT');
        const insured = _.get(policy, 'insuredData_EXT');
        if (insured) {
            const { insuredType } = insured;
            if (insuredType === 'InsuredCompany_EXT') {
                setInsuredTypeCompany(true);
                setRegNoValid(!_.isNil(insured.regNo));
                if (!companyRegValidationCheck(companyRegNumber)) { return false; }
                if (!validateRegNoCheckSum(companyRegNumber)) {
                    return false;
                }
            } else {
                setInsuredTypeCompany(false);
                if (idType === 'saId') {
                    if (_.isUndefined(insuredIdNumber)) {
                        insuredIdNumber = _.get(insured, 'id');
                    }
                    const id = new RegExp(/^([0-9]{13})$/);
                    if (_.isEmpty(insuredIdNumber) || insuredIdNumber === undefined || !id.test(insuredIdNumber)) {
                        handleError(messages.idNoValidationTitle, messages.idNoValidationMessage);
                        return false;
                    }
                    if (!validateIdNo(insuredIdNumber)) {
                        return false;
                    }
                } else {
                    if (_.isUndefined(insuredPassportNumber)) {
                        insuredPassportNumber = _.get(insured, 'passportNumber');
                    }
                    const validPassport = new RegExp(/^([a-zA-Z0-9]{1,13})$/);
                    if (insuredPassportNumber === undefined || !validPassport.test(insuredPassportNumber) || insuredPassportNumber.length > 13) {
                        // eslint-disable-next-line no-use-before-define
                        handleError(
                            messages.passportNoValidationTitle,
                            messages.passportNoValidationMessage
                        );
                        return false;
                    }
                }
            }
        }
        FNOLService.validateInsuredData_Ext(insured, insuredIdNumber, insuredPassportNumber, companyRegNumber, authHeader);
        return ModalNextProvider.showConfirm({
            title: 'Validation Success',
            message: 'Insured\'s identity has been validated',
            confirmButtonText: commonMessages.ok
        }).catch(_.noop);
    }, [FNOLService, authHeader, claimVM.value, expressClaimSelected, idType]);

    const onPreviousWriteup = useCallback(
        () => {
            setRegNumber(_.get(claimVM, 'companyRegistrationNumber'));
            // setIdNumber(_.get(claimVM, 'insuredIdentityNumber'));
            // setPassportNumber(_.get(claimVM, 'insuredPassportNumber'));
            // R2S-509
            if ((typeof _.get(claimVM, 'insuredIdentityNumber')) === 'object') {
                setIdNumber(undefined);
            } else {
                setIdNumber(_.get(claimVM, 'insuredIdentityNumber'));
            }

            if ((typeof _.get(claimVM, 'insuredPassportNumber')) === 'object') {
                setPassportNumber(undefined);
            } else {
                setPassportNumber(_.get(claimVM, 'insuredPassportNumber'));
            }
            if (!_.isNil(_.get(claimVM, 'isFinalLossEstimate_EXT.value'))) {
                const finalLossEstimate = _.get(claimVM, 'isFinalLossEstimate_EXT.value');
                if (finalLossEstimate === true) {
                    setFinalLossEstimate('Yes');
                } else {
                    setFinalLossEstimate('No');
                }
            }
            const expressClaimDetails = _.get(claimVM.value, 'sasriaExpressClaimDetails_EXT');
            if (!_.isUndefined(expressClaimDetails) && !_.isUndefined(expressClaimDetails.isExpressClaimSelected)) { setExpressClaimSelected(expressClaimDetails.isExpressClaimSelected); }
            if (!_.isUndefined(expressClaimDetails)) {
                setFinalLossEstimate(expressClaimDetails.isThisFinalLossEstimate ? 'Yes' : 'No');
            }
            handleCompanyOrInsured();
            const val = checkFinalLossEstimateValidation();
            if (!val) { setExpressClaimSelected(val); }
        }, [checkFinalLossEstimateValidation, claimVM, handleCompanyOrInsured]
    );

    useEffect(() => {
        retrieveVehicleFromPolicy();
        onPreviousWriteup();
        populateRegListonPageLoad();
        retrieveRegYearFromTransunion();
        handleCompanyOrInsured();
        getDefaultIdType();
        updateWizardData(claimVM);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const populateMakeData = useCallback(
        (year, mmcode) => {
            return FNOLService.populateMakeFromTU_EXT(year, mmcode, authHeader)
                .then((makeList) => {
                    const makeDataArray = getCodefilter(makeList);
                    setMakeData(makeDataArray);
                });
        },
        [FNOLService, authHeader, getCodefilter],
    );

    const populateModelData = useCallback(
        (make, year, mmcode) => {
            return FNOLService.populateTUModel_EXT(year, mmcode, make, authHeader)
                .then((modelList) => {
                    const modelDataArray = getCodefilter(modelList);
                    setModelData(modelDataArray);
                });
        },
        [FNOLService, authHeader, getCodefilter],
    );

    const populateVariantData = useCallback(
        (model, make, year, mmcode) => {
            return FNOLService.populateVariantFromTU_EXT(make, year, mmcode, model, authHeader)
                .then((variantsRetrieved) => {
                    const variantDataArray = getCodefilter(variantsRetrieved);
                    setVariantData(variantDataArray);
                });
        },
        [FNOLService, authHeader, getCodefilter],
    );

    const handleSelectedYear = useCallback(
        (yearValue) => {
            _.set(vehicleIncidentVM.value, 'year', yearValue);
            setSelectedYearValue(yearValue);
            updateWizardData(claimVM);
            // const mmcode = _.get(vehicleIncidentVM, 'mCode').value;
            populateMakeData(yearValue, mmCodeValue);
        },
        [vehicleIncidentVM.value, updateWizardData, claimVM, populateMakeData, mmCodeValue]
    );

    const selectMakeValue = useCallback(
        (makeValue) => {
            _.set(vehicleIncidentVM.value, 'make', makeValue);
            setSelectedMake(makeValue);
            updateWizardData(claimVM);
            // const mmcode = _.get(vehicleIncidentVM , 'mmCode').value;
            populateModelData(makeValue, selectedYearValue, mmCodeValue);
        },
        [vehicleIncidentVM.value, updateWizardData, claimVM, populateModelData, selectedYearValue, mmCodeValue]
    );

    const selectModelValue = useCallback(
        (modelValue) => {
            _.set(vehicleIncidentVM.value, 'model', modelValue);
            setSelectedModel(modelValue);
            updateWizardData(claimVM);
            // const mmcode = _.get(vehicleIncidentVM , 'mmCode').value;
            populateVariantData(modelValue, selectedMake, selectedYearValue, mmCodeValue);
        },
        [vehicleIncidentVM.value, updateWizardData, claimVM, populateVariantData, selectedMake, selectedYearValue, mmCodeValue],
    );

    const populateYearListFormmcode = useCallback(
        (mmCode) => {
            mmCode = mmCode == null ? mmCodeValue : mmCode;
            return FNOLService.getYearForMMCode_EXT(mmCode, authHeader)
                .then((regYears) => {
                    const regYearDataArray = getCodefilter(regYears);
                    setYearData(regYearDataArray);
                });
        },
        [FNOLService, authHeader, getCodefilter, mmCodeValue],
    );

    const populateMMCode = useCallback(
        (year, make, model, variant) => {
            return FNOLService.retrieveMMCodeFromOtherSpecifications_EXT(make, variant, year, authHeader)
                .then((mmcodeRetrieved) => {
                    _.set(vehicleIncidentVM.value, 'mmCode', mmcodeRetrieved);
                    // setIsMMCode('Yes');
                    // _.set(vehicleIncidentVM.value, 'haveMMCode', true);
                    _.set(claimVM, 'mmCode', mmcodeRetrieved);
                    setMMCodeValue(mmcodeRetrieved);
                    updateWizardData(claimVM);
                });
        },
        [FNOLService, authHeader, claimVM, updateWizardData, vehicleIncidentVM.value],
    );

    const populateYearFromMMCode = useCallback(
        () => {
            if ((selectedYearValue == null || selectedYearValue === '' || _.isEmpty(selectedYearValue)) && mmCodeValue != null) {
                populateYearListFormmcode(mmCodeValue);
            }
        },
        [mmCodeValue, populateYearListFormmcode, selectedYearValue],
    );

    const selectVariantValue = useCallback(
        (variantValue) => {
            _.set(vehicleIncidentVM.value, 'variant', variantValue);
            setSelectedVariant(variantValue);
            updateWizardData(claimVM);
            populateMMCode(selectedYearValue, selectedMake, selectedModel, variantValue);
        },
        [vehicleIncidentVM.value, updateWizardData, claimVM, populateMMCode, selectedYearValue, selectedMake, selectedModel],
    );

    const handleExtensionValue = useCallback((value) => {
        const extensionPresent = value === 'Yes';
        _.set(vehicleIncidentVM.value, 'claimExtension', extensionPresent);
        // _.set(claimVM, 'propertyIncident_EXT', null);
        setClaimExtension(value);
        if (extensionPresent === true) {
            setExpressClaimSelected(false);
        }
    }, [vehicleIncidentVM.value]);

    const handlePremiumCollection = useCallback((value) => {
        const isPremiumCollection = value === 'Yes';
        _.set(vehicleIncidentVM.value, 'bankPremium', isPremiumCollection);
        // _.set(claimVM, 'propertyIncident_EXT', null);
        setPremiumCollection(value);
        if (isPremiumCollection === false) {
            setExpressClaimSelected(false);
        }
        _.set(vehicleIncidentVM.value, 'expressClaim', null);
    }, [vehicleIncidentVM]);

    const handleLossValue = useCallback((value) => {
        const totalLossPresent = value === 'Yes';
        _.set(vehicleIncidentVM.value, 'totalLoss', totalLossPresent);
        // _.set(claimVM, 'propertyIncident_EXT', null);
        setTotalLoss(value);
        if (totalLossPresent === true) {
            setExpressClaimSelected(false);
        }
    }, [vehicleIncidentVM]);

    const writeValue = useCallback(
        (value, path) => {
            _.set(vehicleIncidentVM, path, value);
            // const newClaimVM = _.clone(claimVM);
            // _.set(newClaimVM, path, value);
            // updateWizardData(newClaimVM);
            _.set(vehicleIncidentVM, 'lossPartyType', lossType);

            if (path === 'mmCode' && value != null && value.length >= 7) {
                setMMCodeValue(value);
                // populateYearFromMMCode();
            }

            if (path === 'mmCode' && _.isEmpty(value)) {
                setMMCodeValue(null);
                setSelectedMake('');
                setSelectedModel('');
                setSelectedVariant('');
            }
            if (path === 'mmCode' && _.isEmpty(value)) {
                retrieveRegYearFromTransunion();
            }
            if (path === 'companyRegistrationNumber') {
                setRegNumber(value);
                _.set(claimVM, 'companyRegistrationNumber', value);
                _.set(claimVM.value, 'companyRegistrationNumber', value);
            }
            if (path === 'insuredIdentityNumber') {
                setIdNumber(value);
                _.set(claimVM, 'insuredIdentityNumber', value);
                _.set(claimVM.value, 'insuredIdentityNumber', value);
            }
            if (path === 'insuredPassportNumber') {
                setPassportNumber(value);
                _.set(claimVM, 'insuredPassportNumber', value);
                _.set(claimVM.value, 'insuredPassportNumber', value);
            }
            // if (path === 'bankPremium') {
            //     setExpressClaimSelected(value);
            //     _.set(vehicleIncidentVM.value, 'expressClaim', null);
            //     _.set(vehicleIncidentVM.value, 'companyRegistrationNumber', null);
            // }
            _.set(claimVM.value, 'vehicleIncident_EXT', vehicleIncidentVM.value);
        },
        [vehicleIncidentVM, lossType, claimVM, retrieveRegYearFromTransunion]
    );
    const selectedenatisCode = useCallback(
        (value) => {
            _.set(vehicleIncidentVM, 'enatisCode', value);
            setEnatisCodeValue(value);
        },
        [vehicleIncidentVM]
    );

    const selectLossType = useCallback(
        (value) => {
            _.set(vehicleIncidentVM, 'lossPartyType', value);
            setLossType(value);
        },
        [vehicleIncidentVM]
    );


    const handleExclVatAmount = useCallback((value) => {
        const policy = _.get(claimVM.value, 'policyData_EXT');
        const vatPercent = _.get(policy, 'vatPercent_EXT', 0);
        const upper = Number(value) * Number(100);
        const exclValue = upper / (Number(vatPercent) + Number(100));
        _.set(vehicleIncidentVM, 'lossEstimate.value', exclValue.toFixed(2));
        _.set(claimVM, 'lossEstimate', vehicleIncidentVM.lossEstimate.value);
    }, [claimVM, vehicleIncidentVM]);

    const addNewVehicle = useCallback(() => {
        _.set(claimVM.value, 'vehicleIncident_EXT', undefined);
        setSelectedYearValue('');
        setSelectedMake('');
        setSelectedModel('');
        setSelectedVariant('');
        setEnatisCodeValue('');
        setHaveFinOut('');
        setHaveLossEstimateValue('');
        setHaveTotalLossValue('');
        setAccessorsCode('');
        setIsMMCode('Yes');
        setMMCodeValue(null);
        setMakeData([]);
        setModelData([]);
        setVariantData([]);
        _.set(claimVM, 'mmCode', undefined);
        _.set(claimVM, 'vehicleRegNo', undefined);
        _.set(claimVM, 'vinNumber', undefined);
        _.set(claimVM, 'engineNumber', undefined);
        _.set(claimVM, 'lossEstimate', undefined);
        _.set(claimVM, 'lossEstimateInclVATValue', undefined);
        _.set(claimVM, 'nonTUValue', undefined);
        setAddNew(!addNew);
        setAddIncidentCard(false);
        vehicleIncidentVM.value = new SasriaVehicleIncident_EXT();
        updateWizardData(claimVM);
    }, [addNew, claimVM, updateWizardData, vehicleIncidentVM.value]);


    const addIncidentCardFunc = useCallback(
        () => {
            const anyLossEstimate = _.get(vehicleIncidentVM, 'haveLossEstimate').value;
            const lossEstimateInclVAT = _.get(vehicleIncidentVM, 'lossEstimateInclVATValue').value;
            if (anyLossEstimate === true) {
                handleExclVatAmount(lossEstimateInclVAT);
            }
            const lossEstimateAmt = _.get(vehicleIncidentVM, 'lossEstimate').value;
            const incidentList = _.get(claimVM, 'vehicleIncidentArray_EXT.value');
            if (vehicleIncidentArray.length === 0 && !_.isUndefined(incidentList) && incidentList.length >= 1) {
                vehicleIncidentArray.push(...incidentList);
            }
            const vinNo = _.get(vehicleIncidentVM, 'vinNumber').value;
            const engineNo = _.get(vehicleIncidentVM, 'engineNumber').value;
            const accessorsCodeSelected = _.get(vehicleIncidentVM, 'haveAccessorsCode').value;
            const vehRgNo = _.get(vehicleIncidentVM, 'vehicleRegNo').value;
            const totalLoss = _.get(vehicleIncidentVM, 'haveTotalLoss').value;
            const enatisCodeSelected = _.get(vehicleIncidentVM, 'enatisCode').value;
            const finout = _.get(vehicleIncidentVM, 'finOut').value;
            const mmCodeVal = _.get(vehicleIncidentVM, 'mmCode').value;

            const regNoValidation = vehicleRegistrationNoMandatory(vehRgNo);
            if (!regNoValidation) {
                return false;
            }

            if (regNoList.includes(vehRgNo)) {
                return handleError(
                    messages.duplicateVehicleAddedTitle,
                    messages.duplicateVehicleCardAddedMessage
                );
            }

            // const isValid = lossEstimateAmountValidation(anyLossEstimate, lossEstimateAmt);
            // if (!isValid) {
            //     return false;
            // }

            if (!lossEstimateAmountIncludingVATValidation(anyLossEstimate, lossEstimateInclVAT)) { return false; }
            // if (!validateLossEstimateInclAndExclValues(anyLossEstimate, lossEstimateAmt, lossEstimateInclVAT)) {
            //     return false;
            // }

            if (!vinnoAndEngNoMandatoryValidation(accessorsCodeSelected, engineNo, vinNo)) {
                return false;
            }

            if (!mandatoryFieldForTotalLoss(totalLoss, enatisCodeSelected, finout)) {
                return false;
            }

            if (_.isUndefined(accessorsCodeSelected)) {
                return handleError(
                    messages.assessorsCodeSelectionValidationId,
                    messages.assessorsCodeSelectionValidationMessage
                );
            }

            if (_.isUndefined(anyLossEstimate)) {
                return handleError(
                    messages.lossEstimateSelectionValidationId,
                    messages.lossEstimateSelectionValidationMessage
                );
            }

            if (_.isUndefined(totalLoss)) {
                return handleError(
                    messages.possibleTotalLossSelectionValidationId,
                    messages.possibleTotalLossSelectionValidationMessage
                );
            }


            _.set(vehicleIncidentVM, 'lossPartyType', lossType);
            regNoList.push(vehRgNo);
            setRegNoList(regNoList);
            if (!_.isUndefined(mmCodeVal) && !_.isEmpty(mmCodeVal)) {
                _.set(vehicleIncidentVM, 'haveMMCode', true);
            } else {
                _.set(vehicleIncidentVM, 'haveMMCode', false);
            }

            // if (isMMCode === 'yes') {
            //     _.set(vehicleIncidentVM, 'haveMMCode', true);
            // }
            // else {
            //     _.set(vehicleIncidentVM, 'haveMMCode', false);
            // }
            const {
                make, model, variant, year, mmCode, vehicleRegNo, haveMMCode, vinNumber, engineNumber, haveLossEstimate,
                haveTotalLoss, lossEstimate, enatisCode, finOut, nonTUValue, lossPartyType, haveAccessorsCode, lossEstimateInclVATValue
            } = vehicleIncidentVM.value;

            const vehicleValue = {
                // eslint-disable-next-line object-property-newline
                make, model, variant, year, mmCode, vehicleRegNo, haveMMCode, vinNumber, engineNumber, haveLossEstimate,
                // eslint-disable-next-line object-property-newlin e
                haveTotalLoss,
                lossEstimate,
                enatisCode,
                // eslint-disable-next-line object-property-newline
                finOut, nonTUValue, lossPartyType, haveAccessorsCode, lossEstimateInclVATValue
            };
            vehicleIncidentArray.push(vehicleValue);
            setVehicleIncidentArray(vehicleIncidentArray);
            _.set(claimVM.value, 'vehicleIncidentArray_EXT', vehicleIncidentArray);
            if (isEditButtonClicked) {
                setIsEditButtonClicked(false);
            }
            setAddIncidentCard(true);
            setAddNew(false);
            setSelectedYearValue('');
            setSelectedMake('');
            setSelectedModel('');
            setSelectedVariant('');
            setEnatisCodeValue('');
            setHaveFinOut('');
            setHaveLossEstimateValue('');
            setHaveTotalLossValue('');
            setAccessorsCode('');
            setIsMMCode('');
            setMMCodeValue(null);
            setMakeData([]);
            setModelData([]);
            setVariantData([]);
            _.set(claimVM.value, 'vehicleIncident_EXT', undefined);
            checkFinalLossEstimateValidation();
            updateWizardData(claimVM);
        },
        [vehicleIncidentVM, claimVM, vehicleIncidentArray, regNoList, lossType, isEditButtonClicked, checkFinalLossEstimateValidation, updateWizardData, handleExclVatAmount]
    );

    const handleMMCode = useCallback(
        (value) => {
            const mmCodePresent = value === 'Yes';
            _.set(vehicleIncidentVM, 'haveMMCode', mmCodePresent);
            setIsMMCode(value);
        },
        [vehicleIncidentVM]
    );

    const handleAccessorCode = useCallback(
        (value) => {
            const accessorsCodePresent = value === 'Yes';
            _.set(vehicleIncidentVM, 'haveAccessorsCode', accessorsCodePresent);
            setAccessorsCode(value);
        },
        [vehicleIncidentVM]
    );

    const handlelossestimate = useCallback(
        (value) => {
            const lossEstimatePresent = value === 'Yes';
            _.set(vehicleIncidentVM, 'haveLossEstimate', lossEstimatePresent);
            _.set(claimVM, 'lossEstimateInclVATValue', null);
            vehicleIncidentVM.lossEstimateInclVATValue = null;

            setHaveLossEstimateValue(value);
        },
        [claimVM, vehicleIncidentVM]
    );

    const handlepossibletotalloss = useCallback(
        (value) => {
            const possibleLossPresent = value === 'Yes';
            _.set(vehicleIncidentVM, 'haveTotalLoss', possibleLossPresent);
            setHaveTotalLossValue(value);
        },
        [vehicleIncidentVM]
    );

    const selectFinanceOutstanding = useCallback(
        (value) => {
            const isFinOutPresent = value === 'Yes';
            _.set(vehicleIncidentVM, 'finOut', isFinOutPresent);
            setHaveFinOut(value);
        },
        [vehicleIncidentVM]
    );


    const handleSelectedVehicle = useCallback(
        (value) => {
            if (!_.isUndefined(value)) {
                setSelectedVehRegNo(value);
                const vehicle = _.find(policyVehicleDataList, { vehicleRegNo: value });
                if (vehicle) {
                    if (vehicleAddedFromDropDown.includes(vehicle)) {
                        return handleError(
                            messages.duplicateVehicleAddedTitle,
                            messages.duplicateVehicleAddedMessage
                        );
                    }
                    vehicleAddedFromDropDown.push(vehicle);
                    setVehicleAddedFromDropDown(vehicleAddedFromDropDown);
                    vehicleIncidentVM.value = new SasriaVehicleIncident_EXT();
                    if (vehicle.vinNumber && vehicle.engineNumber) {
                        _.set(vehicleIncidentVM, 'haveAccessorsCode', true);
                        setAccessorsCode('Yes');
                    } else {
                        _.set(vehicleIncidentVM, 'haveAccessorsCode', false);
                        setAccessorsCode('No');
                    }
                    if (vehicle.mmCode) {
                        _.set(vehicleIncidentVM, 'haveMMCode', true);
                        setIsMMCode('Yes');
                    }
                    _.set(vehicleIncidentVM, 'haveTotalLoss', false);
                    setHaveTotalLossValue('No');
                    _.set(vehicleIncidentVM, 'haveLossEstimate', false);
                    setHaveLossEstimateValue('No');
                    _.set(claimVM, 'vehicleRegNo', vehicle.vehicleRegNo);
                    _.set(vehicleIncidentVM, 'vehicleRegNo', vehicle.vehicleRegNo);
                    _.set(claimVM, 'vinNumber', vehicle.vinNumber);
                    _.set(vehicleIncidentVM, 'vinNumber', vehicle.vinNumber);
                    _.set(claimVM, 'engineNumber', vehicle.engineNumber);
                    _.set(vehicleIncidentVM, 'engineNumber', vehicle.engineNumber);
                    _.set(vehicleIncidentVM, 'make', vehicle.make);
                    setSelectedMake(vehicle.make);
                    _.set(vehicleIncidentVM, 'model', vehicle.model);
                    setSelectedModel(vehicle.model);
                    _.set(vehicleIncidentVM, 'year', vehicle.year);
                    setSelectedYearValue(vehicle.year);
                    _.set(vehicleIncidentVM, 'variant', vehicle.variant);
                    setSelectedVariant(vehicle.variant);
                    setMMCodeValue(vehicle.mmCode);
                    _.set(claimVM, 'mmCode', vehicle.mmCode);
                    _.set(vehicleIncidentVM, 'mmCode', vehicle.mmCode);
                    _.set(claimVM.value, 'vehicleIncident_EXT', vehicleIncidentVM.value);
                }
                updateWizardData(claimVM);

                addIncidentCardFunc();
            }
        },
        [policyVehicleDataList, updateWizardData, claimVM, addIncidentCardFunc, vehicleAddedFromDropDown, vehicleIncidentVM]
    );


    const onNext = useCallback(() => {
        setIsLoading(true);
        const expressClaimDataFromPrevScreen = _.get(claimVM.value, 'sasriaExpressClaimDetails_EXT');
        if (_.isNil(expressClaimDataFromPrevScreen)) {
            const expressClaimDetails = {
                isThisFinalLossEstimate: (isFinalLossEstimate === 'Yes'),
                isExpressClaimSelected: expressClaimSelected,
                totalLossEstimate: totalLossEstimate
            };
            _.set(claimVM.value, 'sasriaExpressClaimDetails_EXT', expressClaimDetails);
        } else {
            _.set(expressClaimDataFromPrevScreen, 'isThisFinalLossEstimate', (isFinalLossEstimate === 'Yes'));
            _.set(expressClaimDataFromPrevScreen, 'isExpressClaimSelected', expressClaimSelected);
            _.set(expressClaimDataFromPrevScreen, 'totalLossEstimate', totalLossEstimate);
            _.set(claimVM.value, 'sasriaExpressClaimDetails_EXT', expressClaimDataFromPrevScreen);
        }
        if (!validateInsuredIdentity()) { return false; }
        return FNOLService.getFNOLDetails_EXT(claimVM.value, authHeader)
            .then((response) => {
                claimVM.value = new Claim(response);
                _.set(claimVM.value, 'totalLossEstimate_Ext', totalLossEstimate);
                return (isFinalLossEstimate === 'Yes' && expressClaimSelected) ? expressClaimsStepsHandling() : normalClaimsStepsHandling();
            })
            .catch((err) => {
                return history.push('/claims');
            })
            .finally(() => {
                setIsLoading(false);
            });
    }, [FNOLService, authHeader, claimVM.value, expressClaimSelected, expressClaimsStepsHandling, history, isFinalLossEstimate, normalClaimsStepsHandling, totalLossEstimate, validateInsuredIdentity]);

    const deleteIncidentCard = useCallback(
        (e, item, index) => {
            e.preventDefault();
            ModalNextProvider.showConfirm({
                title: 'Warning',
                message: 'Are you sure you want to remove this vehicle?',
                status: 'warning',
                icon: 'mi-error-outline',
                confirmButtonText: 'Yes',
                cancelButtonText: 'No'
            }).then(async (results) => {
                if (results === 'cancel') {
                    return _.noop();
                }
                const vehicleIncidentList = _.get(claimVM, 'vehicleIncidentArray_EXT.value');
                vehicleIncidentList.splice((index), 1);
                const { vehicleRegNo } = item;
                setVehicleIncidentArray(vehicleIncidentList);
                const vehicleValue = _.find(policyVehicleDataList, { vehicleRegNo: vehicleRegNo });
                if (vehicleValue) {
                    const updatedList = vehicleAddedFromDropDown.filter((value) => value !== vehicleValue);
                    setVehicleAddedFromDropDown(updatedList);
                }
                if (vehicleRegNo && regNoList.includes(vehicleRegNo)) {
                    const updatedRegList = regNoList.filter((value) => value !== vehicleRegNo);
                    setRegNoList(updatedRegList);
                }
                _.set(claimVM, 'vehicleIncidentArray_EXT.value', vehicleIncidentList);
                _.set(claimVM, 'vehicleIncident_EXT', undefined);
                checkFinalLossEstimateValidation();
                updateWizardData(claimVM);
                return true;
            }, _.noop);
        },
        [claimVM, policyVehicleDataList, regNoList, updateWizardData,
            vehicleAddedFromDropDown, checkFinalLossEstimateValidation]
    );

    const editIncidentCard = useCallback(
        (e, item, index) => {
            e.preventDefault();
            setIsEditButtonClicked(true);
            const vehicleIncidentList = _.get(claimVM, 'vehicleIncidentArray_EXT.value');
            vehicleIncidentList.splice((index), 1);
            setVehicleIncidentArray(vehicleIncidentList);
            _.set(claimVM, 'vehicleIncidentArray_EXT.value', vehicleIncidentList);
            _.set(claimVM.value, 'vehicleIncident_EXT', item);
            vehicleIncidentVM.value = item;
            const {
                make, model, variant, year, mmCode, vehicleRegNo, haveMMCode, vinNumber, engineNumber, haveLossEstimate,
                haveTotalLoss, lossEstimate, enatisCode, finOut, nonTUValue, lossPartyType, haveAccessorsCode, lossEstimateInclVATValue
            } = item;
            if (vehicleRegNo && regNoList.includes(vehicleRegNo)) {
                const updatedList = regNoList.filter((value) => value !== vehicleRegNo);
                setRegNoList(updatedList);
            }
            setSelectedYearValue(year);
            populateMakeData(year, mmCode);
            setSelectedMake(make);
            populateModelData(make, year, mmCode);
            setSelectedModel(model);
            populateVariantData(model, make, year, mmCode);
            setSelectedVariant(variant);
            setMMCodeValue(mmCode);
            setIsMMCode(haveMMCode === true ? 'Yes' : 'No');
            setHaveLossEstimateValue(haveLossEstimate === true ? 'Yes' : 'No');
            setHaveTotalLossValue(haveTotalLoss === true ? 'Yes' : 'No');
            setAccessorsCode(haveAccessorsCode === true ? 'Yes' : 'No');
            setEnatisCodeValue(!_.isUndefined(enatisCode) ? enatisCode : '');
            setHaveFinOut(finOut === true ? 'Yes' : '');
            if (haveTotalLoss === true) {
                setHaveFinOut(finOut === true ? 'Yes' : 'No');
            }
            _.set(claimVM, 'mmCode', mmCode);
            _.set(claimVM, 'vehicleRegNo', vehicleRegNo);
            _.set(claimVM, 'vinNumber', vinNumber);
            _.set(claimVM, 'engineNumber', engineNumber);

            if (haveLossEstimate === true) {
                _.set(claimVM, 'lossEstimate', lossEstimate);
                _.set(claimVM, 'lossEstimateInclVATValue', lossEstimateInclVATValue);
            }
            _.set(claimVM, 'nonTUValue', nonTUValue);
            setLossType(lossPartyType);
            updateWizardData(claimVM);
            setAddIncidentCard(false);
            setAddNew(true);
        },
        [claimVM, populateMakeData, populateModelData, populateVariantData, regNoList, updateWizardData, vehicleIncidentVM.value]
    );

    const generateIncidentCardOverrides = useCallback(() => {
        const incidentArray = _.get(claimVM.value, 'vehicleIncidentArray_EXT', []);
        const overrides = incidentArray.map((elem, index) => {
            return {
                [`deleteIncident${index}`]: {
                    onClick: (e) => {
                        deleteIncidentCard(e, elem, index);
                    }
                },

                [`editIncident${index}`]: {
                    onClick: (e) => {
                        editIncidentCard(e, elem, index);
                    }
                },
            };
        });
        return Object.assign({}, ...overrides);
    }, [claimVM, deleteIncidentCard, editIncidentCard]);

    const fetchVehicleDataWithMMcodeAndYear = useCallback(
        () => {
            setLoadingSpinner(true);
            return FNOLService.getVehicleDetailsFromMMCodeYear(vehicleIncidentVM.mmCode.value, vehicleIncidentVM.year.value, authHeader)
                .then((returnedList) => {
                    if (returnedList.length === 0) {
                        handleError(
                            messages.noVehicleDataFoundTitle,
                            messages.noVehicleDataFoundMessage
                        );
                    } else {
                        setSelectedMake(returnedList[0]);
                        _.set(vehicleIncidentVM.value, 'make', returnedList[0]);
                        populateModelData(returnedList[0], vehicleIncidentVM.year.value, vehicleIncidentVM.mmCode.value);
                        setSelectedModel(returnedList[1]);
                        _.set(vehicleIncidentVM.value, 'model', returnedList[1]);
                        populateVariantData(returnedList[1], returnedList[0], vehicleIncidentVM.year.value, vehicleIncidentVM.mmCode.value);
                        setSelectedVariant(returnedList[2]);
                        _.set(vehicleIncidentVM.value, 'variant', returnedList[2]);
                    }
                    setLoadingSpinner(false);
                });
        },
        [FNOLService, authHeader, populateModelData, populateVariantData, vehicleIncidentVM.mmCode.value, vehicleIncidentVM.value, vehicleIncidentVM.year.value],
    );


    const validateVisibilityOfNextButton = useCallback(() => {
        const incidentArrayVI = _.get(claimVM, 'vehicleIncidentArray_EXT.value', []);
        return ((incidentArrayVI.length !== 0) && isEditButtonClicked === false && addNew === false);
    }, [addNew, claimVM, isEditButtonClicked]);

    useEffect(() => { registerComponentValidation(validateVisibilityOfNextButton); }, [
        registerComponentValidation, validateVisibilityOfNextButton]);

    const overrideProps = {
        vehicleFetchLoader: {
            loaded: loadingSpinner === false
        },

        havemmcode: {
            value: isMMCode
        },
        haveaccessorscode: {
            value: accessorsCode
        },

        lossPartyType: {
            value: lossType
        },

        islossestimate: {
            value: haveLossEstimateValue
        },

        ispossibletotaloss: {
            value: haveTotalLossValue
        },

        financeoutstandingRadioButton: {
            value: haveFinOut,
            visible: haveTotalLossValue === 'Yes'
        },
        vinNo: {
            visible: accessorsCode === 'Yes'
        },
        engineNo: {
            visible: accessorsCode === 'Yes'
        },

        mMCode: {
            visible: isMMCode === 'Yes',
            // onChange: populateYearFromMMCode()

        },

        fetchVehicleWithMMcodeAndYear: {
            visible: isMMCode === 'Yes' && !_.isEmpty(_.get(vehicleIncidentVM, 'mmCode').value) && !_.isUndefined(_.get(vehicleIncidentVM, 'mmCode').value) && !_.isUndefined(_.get(vehicleIncidentVM, 'year').value)
        },

        lossEstimate: {
            visible: false
        },

        sasriaenatisList: {
            value: enatisCodeValue,
            visible: haveTotalLossValue === 'Yes'
        },
        sasriaVehicleList: {
            availableValues: vehicleDataFromPolicy,
            value: selectedVehRegNo,
            visible: addNew !== true
        },

        totalComponent: {
            visible: (addNew === true && addIncidentCard === false)
        },

        NewVehicleId: {
            visible: addNew !== true
        },

        Or: {
            visible: addNew !== true
        },

        year: {
            availableValues: yearData,
            value: selectedYearValue
        },

        make: {
            availableValues: makeData,
            value: selectedMake,
            disabled: isMMCode === 'Yes'
        },

        model: {
            availableValues: modelData,
            value: selectedModel,
            disabled: isMMCode === 'Yes'
        },

        variant: {
            availableValues: variantData,
            value: selectedVariant,
            disabled: isMMCode === 'Yes'
        },
        companyRegistrationNumber: {
            visible: isInsuredTypeCompany && expressClaimSelected && checkFinalLossVal,
            value: regNumber
        },
        isThisFinalLossEstimate: {
            visible: !_.get(claimVM.value, 'sasriaDuplicateClaimExists_EXT', false),
            value: isFinalLossEstimate
        },
        expressClaim: {
            visible: !_.get(claimVM.value, 'sasriaDuplicateClaimExists_EXT', false) && isFinalLossEstimate === 'Yes' && checkFinalLossVal && claimExtension === 'No' && totalLoss === 'No' && premiumCollection === 'Yes',
            value: expressClaimSelected
        },
        insuredIdentityInvalid: {
            visible: expressClaimSelected && idType === 'saId' && !isInsuredTypeCompany && checkFinalLossVal,
            value: idNumber
        },
        insuredPassportInvalid: {
            visible: expressClaimSelected && idType === 'passport' && checkFinalLossVal,
            value: passportNumber
        },
        lossEstimateincludingVat: {
            visible: haveLossEstimateValue === 'Yes'
        },
        selectIdRadioButton: {
            visible: expressClaimSelected && !isInsuredTypeCompany && checkFinalLossVal,
            value: idType
        },
        checkValidation: {
            visible: expressClaimSelected && checkFinalLossVal
        },
        totalLoss: {
            value: totalLoss
        },
        claimExtension: {
            value: claimExtension
        },
        bankPremium: {
            value: premiumCollection
        },
        ...generateIncidentCardOverrides(),

    };

    const resolvers = {

        resolveCallbackMap: {
            selectLossType: selectLossType,
            handleMMCode: handleMMCode,
            handleAccessorCode: handleAccessorCode,
            handlelossestimate: handlelossestimate,
            handlepossibletotalloss: handlepossibletotalloss,
            selectFinanceOutstanding: selectFinanceOutstanding,
            selectedenatisCode: selectedenatisCode,
            handleSelectedVehicle: handleSelectedVehicle,
            addNewVehicle: addNewVehicle,
            populateYear: handleSelectedYear,
            selectMakeValue: selectMakeValue,
            selectModelValue: selectModelValue,
            selectVariantValue: selectVariantValue,
            addIncidentCardFunc: addIncidentCardFunc,
            fetchVehicleDataWithMMcodeAndYear: fetchVehicleDataWithMMcodeAndYear,
            onExpressClaimSwitch: onExpressClaimSwitch,
            handleFinalLossEstimate: handleFinalLossEstimate,
            validateInsuredIdentity: validateInsuredIdentity,
            getIdType: getIdType,
            handleExtensionValue: handleExtensionValue,
            handleLossValue: handleLossValue,
            handlePremiumCollection: handlePremiumCollection
        },

        // resolveComponentMap: {
        //     sasriaMultipleVehicleIncidentCard: SasriaMultipleVehicleIncidentCard
        // },

        resolveClassNameMap: styles

    };

    const readValue = useCallback(
        (fieldId, path) => {
            return readViewModelValue(
                metadata.pageContent,
                claimVM,
                fieldId,
                path,
                overrideProps
            );
        },
        [claimVM, overrideProps]
    );


    return (
        <WizardPage
            disableNext={!isComponentValid}
            onNext={onNext}
            template={WizardPageTemplate}

        >
            <ViewModelForm
                uiProps={metadata.pageContent}
                model={claimVM}
                overrideProps={overrideProps}
                onModelChange={updateWizardData}
                callbackMap={resolvers.resolveCallbackMap}
                componentMap={resolvers.resolveComponentMap}
                classNameMap={resolvers.resolveClassNameMap}
                resolveValue={readValue}
                onValueChange={writeValue}
            // onValidationChange={onValidate}
            />
        </WizardPage>
    );
}
SasriaVehicleIncident.propTypes = wizardProps;
SasriaVehicleIncident.propTypes = {
    history: PropTypes.shape({
        push: PropTypes.func
    }).isRequired
};

export default withRouter(withAuthenticationContext(SasriaVehicleIncident));
